import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the user management table view.
 * @extends JetView
 */
export default class tableUserManagementView extends JetView {
    /**
     * Configures the datatable for user management.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: _('User ID'), width: 150, sort: 'int' }, // User ID column
                {
                    id: 'UserName',
                    header: _('Usuario (Correo electrónico)'),
                    width: 250,
                    sort: 'int',
                }, // User email column
                {
                    id: 'FirstName',
                    header: _('Primer nombre'),
                    width: 200,
                    sort: 'int',
                }, // First name column
                {
                    id: 'LastName',
                    header: _('Apellido'),
                    width: 200,
                    sort: 'int',
                }, // Last name column
                {
                    id: 'CashDeskName',
                    header: _('CashDesk Name'),
                    width: 200,
                    sort: 'int',
                }, // Cash desk name column
                {
                    id: 'IsSuspended',
                    header: _('Estado'),
                    width: 150,
                    sort: 'int',
                }, // Suspension status column
            ],
            footer: true, // Enable footer
            math: true, // Enable mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager configuration
            url: devConfig.geturlApi() + 'es/GetUserManagement', // API endpoint for user management data
        };
    }

    /**
     * Initializes the user management grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        // Event listener for filtering user management data
        this.on(this.app, 'userManagement:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom = // Format start date for query
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo = // Format end date for query
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                // Load data into the grid with filters applied
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });

        // Event listener for item click to trigger user ID event
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with user ID
        });

        // Event listener for player selection to filter grid data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                // Load data into the grid based on selected player ID
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
